module.exports = __webpack_public_path__ + "AssetXpertSCHEMAX.c7f9a2a.jpg";